<template>
   <div class="custom-keyboard"></div>
</template>

<script>
import KeyboardSimple from "simple-keyboard";
import "simple-keyboard/build/css/index.css";
import layout from "simple-keyboard-layouts/build/layouts/french";

export default {
   name: 'KeyboardUI',
   props: {
      keyboardClass: {
         default: "custom-keyboard",
         type: String
      },
      input: {
         type: String
      }
   },
   data () {
      return {
         keyboard:{},
      }
   },
   watch: {
      input(input) {
         this.keyboard.setInput(input);
      }
   },
   mounted() {
      this.keyboard = new KeyboardSimple('.custom-keyboard',{
         theme: "simple-keyboard hg-theme-default hg-layout-default popbook-kbd",
         onChange: input => this.onChange(input),
         onKeyPress: button => this.onKeyPress(button),
         preventMouseDownDefault: true,
         stopMouseDownPropagation: true,
         disableCaretPositioning: true,
         newLineOnEnter: false,
         maxLength: 55,
         layout: {
            default: [
               "\u00B2 & \u00E9 \" ' ( - \u00E8 _ \u00E7 \u00E0 ) = {bksp}",
               "@ a z e r t y u i o p ^ $",
               "# q s d f g h j k l m \u00F9 * {enter}",
               "{shift} < w x c v b n , ; : ! {shift}",
               "{space}"
            ],
            shift: [
               "{//} 1 2 3 4 5 6 7 8 9 0 \u00B0 + {bksp}",
               "@ A Z E R T Y U I O P \u00A8 €",
               "# Q S D F G H J K L M % \u00B5 {enter}",
               "{lock} > W X C V B N ? . / \u00A7 {lock}",
               "{space}"
            ]
         },
         display: {
            "{escape}": "esc ⎋",
            "{tab}": "⇥",
            "{bksp}": "⌫",
            "{enter}": "✓",
            "{lock}": "⬆",
            "{space}": " ",
            "{//}": " ",
            "{shift}": "⇧",
         },

      });
      //let kbd = this.keyboard;

      console.log("keyboard " + this.keyboard);

   },
   methods: {
      setInput(val) {
         //let input = e.target.value;
         this.keyboard.setInput(val);
      },
      onChange(input) {
         //vueInstance.update(input);
         this.$emit('onChange', input);
         console.log("Input changed", input);
      },
      onKeyPress(button) {
         console.log("Button pressed", button);

         /**
         * If you want to handle the shift and caps lock buttons
         */
         if (button === "{shift}" || button === "{lock}")
         this.handleShift();
         else if (button === "{enter}")
         this.$emit('enter');

      },
      handleShift() {
         let currentLayout = this.keyboard.options.layoutName;
         let shiftToggle = currentLayout === "default" ? "shift" : "default";

         this.keyboard.setOptions({
            layoutName: shiftToggle
         });
      },
      reset(){
         //this.input = "";
         this.setInput("");
      }



   }

};

// ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
//   color: $textcolor;
//   opacity: 0.5; /* Firefox */
// }
// ::-ms-input-placeholder { /* Internet Explorer 10-11 */
//   color: $textcolor;
// }
// ::-ms-input-placeholder { /* Microsoft Edge */
//   color: $textcolor;
// }

</script>

<style>


.custom-keyboard {
   font-family: 'Univers Condensed';
   max-width: 850px;
   transform: scale(1.5);
   margin-top: 100px;
   margin-left: auto;
   margin-right: auto;
   pointer-events: auto;
   //overflow: visible;
}

.custom-keyboard.popbook-kbd{
   background: transparent;
   -webkit-filter: drop-shadow( 0px 0px 10px rgba(0, 0, 0, .1));
   filter: drop-shadow( 0px 0px 10px rgba(0, 0, 0, .1));
}
.custom-keyboard.hg-theme-default .hg-button {
   border-radius: 10px;
   box-shadow: none;
   border-bottom: none;
}





</style>
